import { useRef } from 'react';

export function useUniqueId() {
  const uniqueId = useRef(crypto.randomUUID());

  return uniqueId.current;
}
